import { useState } from "react";
import { ArrowRight, Building2, LogOut } from "lucide-react";
import { ApogeuLogo } from "../components/ApogeuLogo";
import { Button } from "../components/Button";
import { MessageBanner } from "../components/MessageBanner";
import { useSession } from "../lib/session/SessionContext";
import { resolveMobileAccess, roleLabel } from "../lib/access";
import type { TenantMembershipDto } from "../types";

interface TenantSelectScreenProps {
  readonly tenants: TenantMembershipDto[];
  readonly onLogout: () => void;
}

export function TenantSelectScreen({ tenants, onLogout }: TenantSelectScreenProps) {
  const { switchTenant, error, activeTenantId } = useSession();
  const [busyId, setBusyId] = useState<string | null>(null);

  const pick = async (tenantId: string) => {
    setBusyId(tenantId);
    await switchTenant(tenantId);
    setBusyId(null);
  };

  return (
    <div className="auth-screen auth-screen--dark">
      <div className="brand-tile brand-tile--large">
        <ApogeuLogo width={54} />
      </div>
      <div className="auth-screen__content">
        <span className="auth-screen__eyebrow">SEUS CENTROS DE TREINAMENTO</span>
        <h1 className="auth-screen__title">Escolha o CT</h1>
        <p className="auth-screen__subtitle">Você tem acesso a mais de um CT. Selecione onde quer entrar agora.</p>
        <div className="tenant-list">
          {tenants.map(tenant => {
            const access = resolveMobileAccess(tenant.roleSlug);
            return (
              <button
                key={tenant.tenantId}
                type="button"
                className={`tenant-option ${tenant.tenantId === activeTenantId ? "tenant-option--active" : ""}`.trim()}
                onClick={() => void pick(tenant.tenantId)}
                disabled={busyId !== null}
              >
                <span className="tenant-option__icon">
                  <Building2 size={20} aria-hidden="true" />
                </span>
                <span className="tenant-option__body">
                  <span className="tenant-option__name">{tenant.name}</span>
                  <span className="tenant-option__role">{access === "denied" ? tenant.roleSlug : roleLabel(access)}</span>
                </span>
                <ArrowRight size={18} aria-hidden="true" />
                {busyId === tenant.tenantId && <span className="tenant-option__busy">Entrando...</span>}
              </button>
            );
          })}
        </div>
        {error && <MessageBanner>{error}</MessageBanner>}
        <Button variant="ghost" fullWidth onClick={onLogout}>
          <LogOut size={16} aria-hidden="true" />
          Sair da conta
        </Button>
      </div>
    </div>
  );
}
